import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const highlightBlockDefaultVariants = {}
const highlightBlockCompoundVariants = []

const highlightBlockSlotNames = [
  [
    "root",
    "highlight-block__root"
  ]
]
const highlightBlockSlotFns = /* @__PURE__ */ highlightBlockSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, highlightBlockDefaultVariants, getSlotCompoundVariant(highlightBlockCompoundVariants, slotName))])

const highlightBlockFn = memo((props = {}) => {
  return Object.fromEntries(highlightBlockSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const highlightBlockVariantKeys = []
const getVariantProps = (variants) => ({ ...highlightBlockDefaultVariants, ...compact(variants) })

export const highlightBlock = /* @__PURE__ */ Object.assign(highlightBlockFn, {
  __recipe__: false,
  __name__: 'highlightBlock',
  raw: (props) => props,
  variantKeys: highlightBlockVariantKeys,
  variantMap: {},
  splitVariantProps(props) {
    return splitProps(props, highlightBlockVariantKeys)
  },
  getVariantProps
})